import { assertUnreachable } from '@sgme/fp';

import type { AlgoOrderType } from '@/store/orders/state.ts';

export function mapOrderTypeToWebApiPathComponent(orderType: AlgoOrderType): string {
  switch (orderType) {
    case 'Twap+Order':
      return 'Twap';
    case 'NightjarOrder':
      return 'Nightjar';
    case 'FalconOrder':
      return 'Falcon';
    default:
      return assertUnreachable(orderType, `unknown order type ${orderType}`);
  }
}
